import { defineStore } from 'pinia'
import { SectionsClass } from '@/api/fields'
import type { IServerParams } from '@/types/serverParams.type'

type AfterSetFieldsCallback = (store: ReturnType<typeof useFieldsStore>) => void

// TODO_VUE: нужно отрефакторить, фактически стор не полей, а секций.
export const useFieldsStore = defineStore('fields', {
  state: () => ({
    fields: null as SectionsClass | null,
    entityType: null as string | null,
    afterSetFields: [] as AfterSetFieldsCallback[]
  }),
  actions: {
    setFields (fields: SectionsClass) {
      this.fields = fields

      this.afterSetFields.forEach((callback) => {
        callback(this)
      })
    },

    setEntityType (entityType?: string) {
      this.entityType = entityType || null
    },

    setAfterSetFields (callbacks: AfterSetFieldsCallback[]) {
      this.afterSetFields = callbacks
    },

    setCustomTab (tab: NonNullable<IServerParams['Tabs']>[number]) {
      if (this.fields?.params) {
        this.fields.params.Tabs = this.fields.params.Tabs || []

        // Проверка на наличие вкладки
        if (this.fields.params.Tabs.some(currentTab => currentTab.UrlKey === tab.UrlKey)) return

        this.fields.params.Tabs.push(tab)
      }
    }
  },
  getters: {
    getFields: (state) => state.fields,

    getEntityType: (state) => state.entityType,

    getParams: (state) => state.fields?.params,

    getUuid: (state) => state.fields?.params?.Uuid
  }
})
